<form class="filter" [formGroup]="hsProcessingFilterForm" (submit)="applyMatchingFilters()">
<modal-panel
    data-testid="hs-processing-filter-modal-panel"
    class="matching-vcc-filter-modal-panel-cls filter-panel"
    [title]="'Filter'"
    (close)="handleBookingFiltersFormCloseEvent();"
    >
        <div data-testid="hs-processing-filter-modal-div-2" class="filter__fields">
            <mat-grid-list class="modal-filter-col-flex" [cols]="isSmall ? 1 : 2" gutterSize="10px" rowHeight="85">
                <mat-grid-tile>
                    <mat-form-field>
                        <mat-label>Date Created From</mat-label>
                        <input matInput [matDatepicker]="picker1" formControlName="dateCreatedFrom">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        @if(hsProcessingFilterForm.controls['dateCreatedFrom'].value){
                            <button 
                                data-testid="hs-processing-date-created-from-clear-filter-button"
                                matSuffix mat-icon-button
                                type="button"
                                (click)="clearMatchingFields('dateCreatedFrom')">
                                    <mat-icon>close</mat-icon>
                            </button>
                        } @else {
                            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        }
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile>
                    <mat-form-field>
                        <mat-label>Date Created To</mat-label>
                        <input matInput [matDatepicker]="picker2" formControlName="dateCreatedTo">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker #picker2></mat-datepicker>
                        @if(hsProcessingFilterForm.controls['dateCreatedTo'].value){
                            <button 
                                data-testid="hs-processing-date-created-to-clear-filter-button"
                                matSuffix mat-icon-button
                                type="button"
                                (click)="clearMatchingFields('dateCreatedTo')">
                                    <mat-icon>close</mat-icon>
                            </button>
                        } @else {
                            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                        }
                    </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile>
                    <dynamic-autocomplete
                        [formControl]="adxReferenceControl"
                        [formLabel]="'Adx Reference'" 
                        [tableName]="'TransactionBooking'"
                        [columnName]="'TripReference'"
                        [emitString]="true"
                        [dataTestId]="'hs-processing-adx-reference-autocomplete'"
                    ></dynamic-autocomplete>
                </mat-grid-tile>
                <mat-grid-tile>
                    <dynamic-autocomplete
                        [formControl]="hsTicketNumberControl"
                        [formLabel]="'Hs Ticket'"
                        [tableName]="'Task'"
                        [columnName]="'ExternalNumber'"
                        [emitString]="true"
                        [dataTestId]="'hs-processing-hs-ticket-autocomplete'"
                    ></dynamic-autocomplete>
                </mat-grid-tile>
            </mat-grid-list>
            <mat-grid-list cols="1" gutterSize="10px" rowHeight="85">
                <mat-grid-tile>
                    <div style="width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 16px;">
                        <p style="margin: 0; font-size: 14px; flex: 0 0 auto; min-width: 80px;">Invalid</p>
                        <div style="display: flex; justify-content: center; align-items: center; flex: 1;">
                            <mat-radio-group formControlName="invalid" aria-label="is-invalid" [color]="'primary'" style="display: flex; gap: 24px;">
                                <mat-radio-button value="true" style="margin: 0;">Yes</mat-radio-button>
                                <mat-radio-button value="false" style="margin: 0;">No</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <button 
                            data-testid="hs-processing-is-invalid-clear-filter-button"
                            mat-icon-button
                            type="button"
                            style="flex: 0 0 auto;"
                            (click)="clearMatchingFields('invalid')">
                                <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
        </div>
        <ng-container data-testid="hs-processing-modal-footer-container" modalPanelFooter>
            <div class="modal-footer">
                <button data-testid="hs-processing-filter-modal-button-clear-all" mat-stroked-button color="primary" type="button" (click)="clearMatchingFields()">
                    <mat-icon data-testid="hs-processing-filter-clear-all-filter-button-icon">delete_outline</mat-icon>
                    Clear All
                </button>
                <button data-testid="hs-processing-modal-button" mat-raised-button color="primary" type="submit">Apply</button>
            </div>
        </ng-container>
</modal-panel>
</form>